<template>
    <header class="cz2__splash-header">
        <funko-logos />

        <h1 class="cz2__font-inter-black cz2__splash-heading">
            {{ $t('SPLASH_HEADING') }}
        </h1>

        <h2 class="cz2__splash-subheading">
            {{ $t('SPLASH_SUBHEADING') }}
        </h2>

        <a
            v-if="!isKiosk && hasVideo"
            href="#cz2__splash-video"
            class="cz2__splash-video-link"
        >
            <img
                src="../assets/icons/play-icon.svg"
                aria-hidden="true"
                alt=""
            >
            {{ $t('SPLASH_VIDEO_LINK') }}
        </a>
    </header>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__splash-header {
            width: 100%;
            padding: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;

            .cz2__splash-heading {
                margin: 8px 0;
                font-style: italic;
                letter-spacing: 0;
                line-height: 30px;
                font-size: 28px;
            }

            .cz2__splash-subheading,
            .cz2__splash-video-link {
                font-family: "Proxima Nova";
                font-weight: 500;
                font-size: 16px;
            }

            .cz2__splash-video-link {
                margin-top: 16px;
                display: flex;
                align-items: center;
                gap: 8px;
                color: black;
            }

            @include respond-above(lg) {
                padding: 24px;

                .cz2__splash-heading {
                    font-size: 32px;
                }
            }
        }
    }
</style>

<script>
    import FunkoLogos from './FunkoLogos.vue';

    export default {
        name: 'SplashHeader',

        components: {
            FunkoLogos,
        },

        props: {
            hasVideo: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },
    };
</script>
